export const HANDIN_PROVIDER = 'hand-in';
export const TURNITIN_PROVIDER = 'turnitin';
export const QUIZZES_PROVIDER = 'quizzes';
export const LTI1P3_PROVIDER = 'lti-1p3';
export const MANUAL = 'manual';
